import { render, staticRenderFns } from "./ProjectObservationsFormMissing.vue?vue&type=template&id=9226672c&"
import script from "./ProjectObservationsFormMissing.vue?vue&type=script&lang=js&"
export * from "./ProjectObservationsFormMissing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9226672c')) {
      api.createRecord('9226672c', component.options)
    } else {
      api.reload('9226672c', component.options)
    }
    module.hot.accept("./ProjectObservationsFormMissing.vue?vue&type=template&id=9226672c&", function () {
      api.rerender('9226672c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/projects/ProjectObservationsFormMissing.vue"
export default component.exports